<template>
  <h1>Customer Review</h1>
</template>

<script setup lang="ts"></script>

<style lang="postcss" scoped></style>
